(function () {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  document.querySelectorAll('.rv').forEach((el, i) => {
    if (!el.closest('.hero')) {
      el.style.transitionDelay = (i % 4) * 0.07 + 's';
    }
    io.observe(el);
  });

  window.addEventListener('load', () => {
    document.querySelectorAll('.hero .rv').forEach((el) => el.classList.add('in'));
  });

  setTimeout(() => {
    document.querySelectorAll('.hero .rv').forEach((el) => el.classList.add('in'));
  }, 120);
})();
